import * as Yup from 'yup';
import { getUsernameValidator } from '../../../common/utils/username-validator';

export const validationSchema = Yup.object().shape({
	username: getUsernameValidator()
});
